import { create } from 'zustand';
import { IProfileStore } from './types';

export const useProfileStore = create<IProfileStore>((set) => ({
  profilePic: '',
  file: '',
  newProfilePic: '',
  updateProfilePicStore: ({ profilePic }: { profilePic: string }) => set(() => ({ profilePic })),
  newProfilePicStore: ({ newProfilePic }: { newProfilePic: string }) => set(() => ({ newProfilePic })),
}));

export default useProfileStore;
